import { render } from "./switch-btn.vue?vue&type=template&id=e6944aa8&ts=true"
import script from "./switch-btn.vue?vue&type=script&lang=ts"
export * from "./switch-btn.vue?vue&type=script&lang=ts"

import "./switch-btn.vue?vue&type=style&index=0&id=e6944aa8&lang=scss"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__